import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { Sensor, ReturnDataSensorDataItem } from "../models";

interface ReturnDataString {
    error?: string;
    data?: string;
}

export default class AmbientalWidgetsAPI {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getData(pk_cuaa: number, lot_id: number, requestedSensor: string): Promise<ReturnDataSensorDataItem> {
        const { error, data } = await this.getIdFromLinkedStation(pk_cuaa, lot_id);

        if (error || !data) return { error };

        const sensorType = await this.checkSensorType(pk_cuaa, data, requestedSensor);

        if (sensorType.error) return { error: sensorType.error };

        const sensorHistoryData = await this.getSensorDataItems(
            pk_cuaa,
            data,
            requestedSensor,
            (new Date(new Date().setTime(new Date().getTime() - 604800000))).toISOString(),
            new Date().toISOString()
        );

        if (sensorHistoryData.error) return { error: sensorHistoryData.error };

        return { data: sensorHistoryData.data };
    }

    private async getIdFromLinkedStation(farmId: number, lotId: number): Promise<ReturnDataString> {
        const res = await this.http.get(`/iot/api/v1/farm/${farmId}/plots/${lotId}/stations`);

        return res.data.length > 0 ? { data: res.data[0] } : { error: "no-station-connected" };
    }

    private async checkSensorType(
        farmId: number,
        stationId: string,
        requestedSensor: string
    ): Promise<{ error?: string }> {

        const res = await this.http.get(`/sensor-x/api/v1/farm/${farmId}/stations/${stationId}/sensors`);

        if (!res.data.backendStatus.ok.includes("xearpro")) return { error: "station-has-not-xearpro" };

        const correctSensor = res.data.results.find((el: Sensor) => el.id === requestedSensor);
        if (!correctSensor) return { error: "station-has-not-correct-sensor" };

        return {};
    }

    public async getSensorDataItems(
        pkCuaa: number,
        stationId: string,
        sensorId: string,
        fromParameter: string,
        toParameter: string
    ): Promise<ReturnDataSensorDataItem> {

        let res;

        try {
            res = await this.http.get(
                `/sensor-x/api/v1/farm/${pkCuaa}/stations/${stationId}/sensors/${sensorId}/data`,
                { params: { from: fromParameter, to: toParameter } }
            );
        } catch (e) {
            return { error: "sensor-has-no-data" };
        }

        return { data: res.data.results };
    }
}

